require("navigation");

//var wow = new WOW().init();

// ----------------------------------- //
// ANIMATION BACKGROUND 3 BOUTONS PUSH //
// ----------------------------------- //
function push_bg_animation() {
  /*
  var start_animation_at = $("#banner-push").offset().top ;
  var current_scroll = $(window).scrollTop();
  var test_top = start_animation_at - current_scroll;
  if(test_top < 283) {
    $('#banner-push-bottom').css({'height':test_top+'px'});
    $('#banner-push-bottom-polygon').attr('points','1600,'+test_top+' 0,0 3200,0');
  }
  */
}

$(document).ready(function(){
  // Les slider
  var hs_box = document.querySelector('#hs-box');
  var mc = new Hammer(hs_box);
  var slider = $("#homeslider ul");
  slider.bxSlider({
    mode: 'fade',
    minSlides: 1,
    maxSlides: 1,
    auto: true,
    autoHover: true,
    speed: 1000,
    pause: 5000,
    pager: false,
    nextText: '',
    prevText: ''
  });

  mc.on("swipeleft", function() {
    slider.goToNextSlide();
  });
  mc.on("swiperight", function() {
    slider.goToPrevSlide();
  });
  // Lien vers ancre sous ligne de flottaison
  $('#hs-scroll-bot').on('click',function() {
    // var page = $(this).attr('data-href'); // Page cible
    var speed = 750;
    var hauteur_to_scroll = $("#banner-push").offset().top - $('#header').height() + 37 ;
    $('html, body').animate( { scrollTop: hauteur_to_scroll }, speed ); // Go
    return false;
  });

  //wow.sync();
});
